export const initGallery = () =>
  Array.from(document.querySelectorAll('aside[data-gallery]')).forEach((aside) => {
    const slides = Array.from(aside.querySelectorAll('li[data-gallery-slide]'))
    const navs = Array.from(aside.querySelectorAll('button[data-gallery-i]'))
    const prev = aside.querySelector('button[data-gallery-prev]')
    const next = aside.querySelector('button[data-gallery-next]')
    const total = slides.length
    const navToggleClasses = ['ring-4', '!ring-primary']
    const slideToggleClasses = ['hidden']

    const getCurrent = () => Number.parseInt(aside.dataset.galleryCurrentSlideNumber)

    const select = (i) => {
      i = (i + total) % total

      const current = getCurrent()

      if (i === current) {
        return
      }

      navs[i].classList.add(...navToggleClasses)
      navs[current].classList.remove(...navToggleClasses)

      slides[current].classList.add(...slideToggleClasses)
      slides[i].classList.remove(...slideToggleClasses)

      aside.dataset.galleryCurrentSlideNumber = i
    }

    const selectPrev = () => select(getCurrent() - 1)

    const selectNext = () => select(getCurrent() + 1)

    prev?.addEventListener('click', selectPrev)
    next?.addEventListener('click', selectNext)
    aside.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowRight') {
        selectNext()
        navs[getCurrent()].focus()
      } else if (event.key === 'ArrowLeft') {
        selectPrev()
        navs[getCurrent()].focus()
      }
    })
    navs.forEach((button) => button.addEventListener('click', () => select(Number.parseInt(button.dataset.galleryI))))
  })
